<template>
  <div>
    <a-card size="small" title="redis列表">


        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
            <a-form-item label="版本">
                <a-select show-search v-model="searchP.version" placeholder="选择版本" @change="handleVersionChange"  allow-clear style="width: 150px">
                    <a-select-option v-for="d in versionList" :key="d">
                        {{ d }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="系统端口">
                <a-select show-search v-model="searchP.mastername" placeholder="选择系统端口"  allow-clear style="width: 250px">
                    <a-select-option v-for="d in masternames[searchP.version]" :key="d+prex">
                        {{ d+prex }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="KEY">
                <a-select show-search :value="searchP.key" placeholder="输入key关键字匹配" style="width: 700px"  allow-clear
                    :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="fetching ? undefined : null"
                    @search="handleSearch" @change="handleChange">
                    <a-select-option v-for="d in keyList" :key="d.value">
                        {{ d.text }}
                    </a-select-option>
                     <template v-if="fetching" #notFoundContent>
                        <a-spin size="small" />
                    </template>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="handleSubmit">查询</a-button>
            </a-form-item>
        </a-form>
        <div style="padding-top:10px;">
            <span>系统端口：{{searchP.version + '_' + searchP.mastername}}</span>
            <a-popconfirm :title="'确认要清理' + searchP.version + '_' + searchP.mastername + '下所有缓存？'" @confirm="() => handlClear()" style="margin-left:20px;">
                <a class="tableLink"  href="javascript:;">清理所有緩存</a>
            </a-popconfirm>

            <span style="margin-left:20px;">Key：{{searchP.key}}</span>
            <a-popconfirm  :title="'确认删除 ' + searchP.version + '_' + searchP.mastername + '_' + searchP.key +'?'" @confirm="() => handlClearKey()" style="margin-left:20px;">
                <a v-show="searchP.key" class="tableLink"  href="javascript:;">删除缓存</a>
            </a-popconfirm>
        </div>
                <a-spin :spinning="formLoading">

        <JsonXmlEditor :language="'json'" :height="screenHeight" :title="'值：'" v-model="data"></JsonXmlEditor>
                </a-spin>

    </a-card>


  </div>
</template>
<script>
import JsonXmlEditor from '../../../components/JsonXmlEditor'

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            prex:'_master_1',
            versionList:['v3','v5-qt','v5-jt','v5-zt'],
            masternames:{
                'v3':[
                    'api',
                    'basic',
                    'dcms',
                    'dwms',
                    'entry',
                    'fk',
                    'fms',
                    'fpapi',
                    'fp',
                    'jobms',
                    'mbms',
                    'mcms',
                    'oms',
                    'open',
                    'passport',
                    'pays',
                    'salems',
                    'sms',
                    'stms',
                    'ums',
                    'urms',
                    'wsms',
                    'accms',
                    'acts',
                    'chms',
                    'ifms',
                    'malls',
                    'osrms',
                    'posms',
                    'wxms',
                    'zkms',
                    'cdhs',
                ],
                'v5-qt':[
                    'actsv5',
                    'basicv5',
                    'chmsv5',
                    'dcmsv5',
                    'ifmsv5',
                    'mallsv5',
                    'osrmsv5',
                    'passportv5',
                    'posmsv5',
                    'wxmsv5',
                    'opmsv5',
                    'zkmsv5',
                ],
                'v5-jt':[
                    'apiv5',
                    'basicv5',
                    'entryv5',
                    'fkv5',
                    'fmsv5',
                    'fpapiv5',
                    'fpv5',
                    'jobmsv5',
                    'mcmsv5',
                    'openv5',
                    'passportv5',
                    'smsv5',
                    'umsv5',
                    'wsmsv5',
                    'zkmsv5',
                ],
                'v5-zt':[
                    'accmsv5',
                    'cdhsv5',
                    'dcmsv5',
                    'dwmsv5',
                    'entryv5',
                    'mbmsv5',
                    'omsv5',
                    'passportv5',
                    'paysv5',
                    'salemsv5',
                    'stmsv5',
                    'urmsv5',
                    'zkmsv5',
                ]
            },
            searchP:{
                version:'v3',
                mastername:'',
                key:undefined
            },
            keyList:[],
            searchTimmer:null,
            data:'',
            screenHeight:window.innerHeight - 300,
            formLoading:false,
            fetching:false,
        };
    },
    methods: {

        handleSubmit(){
            let that = this
            that.formLoading = true;
            let params = {
                ...that.searchP,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'redis/getvalues',
                params:params
            }).then((res)=>{
                that.formLoading = false
                if(res.status == 200 && res.data.success == '1'){
                    that.data = JSON.stringify(res.data.data);
                }
            }).catch(() => {
                that.formLoading = false

            });
        },
        handlClear(){
            let that = this
            let params = {
                ...that.searchP,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'redis/delallkey',
                params:params
            }).then(()=>{
                this.handleSubmit();
            }).catch(() => {

            });
        },
        handlClearKey(){
            let that = this
            let params = {
                ...that.searchP,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'redis/delkey',
                params:params
            }).then(()=>{
                this.handleSubmit();
            }).catch(() => {

            });
        },
        handleVersionChange(){
            this.searchP.mastername = this.masternames[this.searchP.version][0]+this.prex
        },

        handleChange(value) {
            this.searchP.key = value;
        },
        handleSearch(value) {
            let that = this;
            that.searchP.key = value;
            if(that.searchTimmer){
                clearTimeout(that.searchTimmer)
                that.searchTimmer = null;
            }
            that.searchTimmer = setTimeout(() => {
                that.doSearch();
                that.searchTimmer = null;
            }, 1000);
        },
        doSearch() {
            let that = this;
            that.fetching = true;
            let c_params = {
                ...that.searchP,
                urlparams: false,

            }
            that.$store.dispatch({
                type: "redis/key",
                params: c_params,
                showMsg: false
            }).then((res) => {
                that.fetching = false;

                if (res.data.success == 1) {
                    that.keyList = [];
                    let result = res.data.data;
                    result.forEach(r => {
                        that.keyList.push({
                            value: r.key,
                            text: r.key,
                        });
                    });
                    console.log(that.keyList)
                }
            }).catch(() => {
                that.fetching = false;

            });
        },
    },
    components:{
        JsonXmlEditor
    },
    mounted(){
        this.searchP.mastername = this.masternames[this.searchP.version][0]+this.prex
    }
};
</script>
<style scoped>

</style>
